import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { NegotiationRoundStatus } from "../../../autogen/bff-api";

// Dynamic lookups — langen can't see these statically:
// t("Draft") t("Published") t("Completed")
const meta: Record<NegotiationRoundStatus, { color: string; labelKey: string }> = {
  [NegotiationRoundStatus.Draft]: { color: "orange", labelKey: "Draft" },
  [NegotiationRoundStatus.Published]: { color: "green", labelKey: "Published" },
  [NegotiationRoundStatus.Completed]: { color: "gray", labelKey: "Completed" },
};

interface Props {
  status: NegotiationRoundStatus;
  size?: "sm" | "md" | "lg";
}

export const NegotiationRoundStatusTag = ({ status, size = "sm" }: Props) => {
  const { t } = useTranslation();
  const { color, labelKey } = meta[status] ?? { color: "gray", labelKey: status as string };
  return (
    <Tag colorScheme={color} size={size} borderRadius="full">
      {t(labelKey)}
    </Tag>
  );
};
